import { CardHorizontal, FavouriteButton, Image } from "@capioweb/ui-components"
import React, { useState } from "react"
import { Link } from "react-router-dom"
import {
	ContentLink,
	PropertyCategory,
	QBankImage,
	XhtmlString,
} from "../../@types/CapioWeb/core"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { imageBlockDataToImageProps } from "../../utils"
import { onFavButtonClick } from "../MyPagesPersonalizedArticlesBlock/api"

export interface SavedArticleProps {
	name: string
	heading: StringProperty
	preamble: XhtmlString
	imageDesktopBlock?: QBankImage
	categories: PropertyCategory
	contentLink: ContentLink
}

const SavedArticle: React.FC<SavedArticleProps> = (props) => {
	const [filled, setFilled] = useState(true)
	const srcSetSizes = [
		{ width: 900, breakpoint: 768 },
		{ width: 1200, breakpoint: 2560 },
	]
	return (
		<Link to={props.contentLink?.url ?? "#"} style={{ width: "100%" }}>
			<CardHorizontal
				media={
					props.imageDesktopBlock?.media?.value ? (
						<img
							{...imageBlockDataToImageProps(
								props.imageDesktopBlock,
								false,
								true,
								srcSetSizes
							)}
						/>
					) : null
				}
				tag={
					props.categories.value.length > 0 &&
					props.categories.value[0].description
				}
				favButton={
					<FavouriteButton
						filled={filled}
						onClick={(e) => {
							e.preventDefault()
							onFavButtonClick(props.contentLink.guidValue, filled, setFilled)
						}}
					/>
				}
				borderColor="blue33"
			>
				<CardHorizontal.Title>
					{props.heading?.value || props.name}
				</CardHorizontal.Title>
				{props.preamble?.value !== "" && (
					<CardHorizontal.Preamble>
						{props.preamble.value}
					</CardHorizontal.Preamble>
				)}
			</CardHorizontal>
		</Link>
	)
}

export { SavedArticle }
